export const designationOptions = [
  { value: "0", name: "Administrator" },
  { value: 1, name: "Manager" },
  { value: 2, name: "Privacy Officer" },
  { value: 3, name: "Operation Management" },
  { value: 4, name: "Staff Allocation" },
  { value: 5, name: "Senior Carer/Nurse" },
  { value: 6, name: "Carer/Domestic" },
];

export const locationOptions = [
  { name: "Croydon 1", value: "croydon1" },
  { name: "Croydon 2", value: "croydon2" },
  { name: "London Central", value: "london_central" },
  { name: "Birmingham", value: "birmingham" },
];
